/* eslint-disable bam/no-react-unbound */

import { domIsReady, watchAddedNodes } from "../../utils";

export default class GoogleTagManagerService {
  constructor(selector, trackingMethod) {
    this.callback = trackingMethod;

    this.init(selector);
  }

  async init(selector) {
    await domIsReady();
    watchAddedNodes((nodes) => {
      this.generateObserver(nodes);
    }, selector);
  }

  /**
   * Process nodes
   */
  generateObserver(nodes) {
    this.observer && this.observer.disconnect();

    this.observer = new IntersectionObserver((inttersectedEls) => {
      const elements = inttersectedEls.filter((e) => e.isIntersecting).map((e) => e.target);
      elements.forEach((e) => this.observer.unobserve(e));
      this.callback(elements);
    });

    nodes.forEach((node) => {
      this.observer.observe(node);
    });
  }

  static instances = [];

  static registerInstance(selector, trackingMethod) {
    this.instances.push(new GoogleTagManagerService(selector, trackingMethod));
  }
}
